import { ofType } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';

import {
    FETCH
} from 'one-state-updateincidents/src/types';

import {
    setAction,resetAction
} from 'one-state-updateincidents/src/actions';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import { Disposition } from 'one-model-local';

import {format} from 'one-util-date';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    SET,
    RESET
} from 'one-state-subject/src/types';
/**
 * This Fuction will intiate update incident via put method to
 *  backend api and returns status
 * @param context contains the settings etc..
 */
 export const enum Types {
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

export const fetchUpdateIncidentsEpic = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { serverone,agentId,teamName, log, settings: { compatible, epicendpoints,servers,uisettings } } = context;
        const {  apitoken,updateincident } = epicendpoints;
        const { contact_center_type } = compatible;
        const {
            dashboardapiconfig: {
                updateincident : updateincidentApi
            }
        } = uisettings;
        return action$.pipe(
            ofType(FETCH),
            // ofType(Types.PatientSet),
           
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                
                 let dataresponse:any = action.payload;
                const getRequest = (payload: any) => {
               
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);
                        headers.append("Accept", "application/json");
                        
                        headers.append("Content-Type", "text/plain");
                        const data= {
                            description: payload.description ? payload.description : "",
                            short_description: payload.short_description ? payload.short_description : "",
                            category: payload.category ? payload.category : "",
                            caller_id: payload.caller_id ? payload.caller_id : "",
                            state: payload.state ? payload.state : "",
                            sysparm_display_value: true,
                            sysparm_exclude_reference_link: true,
                            sysparm_fields: "number,short_description,priority,state,state,sys_id,sys_created_on",
                          }
                        const response = serverone.put({
                            path: updateincident,
                            data: data,
                            headers: headers
                        })
                        .then((responsefound: any) => {
                            // treating as success for screenpop
                            
                            log.debug(
                                "ccw-gadget,screenpop-epic",
                                "update-incident response", {
                                    responsefound
                            });
                            let result = responsefound;
                            return result;
                        })
                        .catch((responseresult: any) => {
                                 //Check the Side B server receive communication
                      
                            log.error(
                                "ccw-gadget,update-incident",
                                "update-incident", {
                                responseresult
                            }
                            );
                            let result = responseresult;
                            return result;   
                        })
                    return from(response)

                }
                //Calling getRequst function here
                //the reason is we need to use pipe function.
                if (!updateincidentApi) return []
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => response)
                    ).
                    pipe(
                        flatMap((response: any) => {
                                const actions:any = [
                                   setAction(response)
                                ];
                               
                                if(response?.errors && response?.errors?.length > 0){
                               /*changes for errors will pushed to bell icon*/
                                    let errorbuild:ErrorObject = {
                                   source: "UpdateIncident",
                                   type: "error",
                                   status: response?.status,
                                   erroritems: response?.errors,
                                   error_date: errorDate,
                                   error_time: errorTime
                               };
                               actions.push(addAction(errorbuild))
                               let disp: Disposition = { value: "1017" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } 
                                else if(contact_center_type==="genesys"){
                                    disp.meta00 = sessionStorage.getItem("name");
                                    disp.meta01 = sessionStorage.getItem("agentName");
                                  }
                                  else if(contact_center_type==="twilio"){
                                    disp.meta00 = sessionStorage.getItem("twilio_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="ringcentral"){
                                    disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="inContact"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                  }
                                  else if(contact_center_type==="vonage"){
                                    disp.meta00 = sessionStorage.getItem("vonage_userid");
                                    disp.meta01 = "";
                                  }
                                  else if(contact_center_type==="wxcc"){
                                    disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                    disp.meta01 = "";
                                  } 
                                  else if(contact_center_type==="intermedia"){
                                    disp.meta00 = sessionStorage.getItem("agentName");
                                    disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                                  }  
                                else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = response?.error?.status;
                                disp.meta03 = dataresponse.caller_id;
                                actions.push(pushToDisposition(disp));
                                } else {
                                    let disp: Disposition = { value: "201" }
                                    if (contact_center_type && contact_center_type === 'five9') {
                                        let agentIdValue = sessionStorage.getItem("agentName");
                                        let skillName = sessionStorage.getItem("skillName");
                                        disp.meta00 = agentIdValue;
                                        disp.meta01 = skillName;
                                        disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                    } 
                                    else if(contact_center_type==="genesys"){
                                        disp.meta00 = sessionStorage.getItem("name");
                                        disp.meta01 = sessionStorage.getItem("agentName");
                                      }
                                      else if(contact_center_type==="twilio"){
                                        disp.meta00 = sessionStorage.getItem("twilio_userid");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="ringcentral"){
                                        disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="inContact"){
                                        disp.meta00 = sessionStorage.getItem("agentName");
                                        disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                                      }
                                      else if(contact_center_type==="vonage"){
                                        disp.meta00 = sessionStorage.getItem("vonage_userid");
                                        disp.meta01 = "";
                                      }
                                      else if(contact_center_type==="wxcc"){
                                        disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                        disp.meta01 = "";
                                      } 
                                      else if(contact_center_type==="intermedia"){
                                        disp.meta00 = sessionStorage.getItem("agentName");
                                        disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                                      }  
                                    else {
                                        disp.meta00 = agentId;
                                        disp.meta01 = teamName;
                                        disp.dial_list_uid = state$.value.choosecaller?.callId;
                                    }
                                    disp.meta02 = dataresponse.caller_id;
                                    actions.push(pushToDisposition(disp));
                                }
                               return actions;
                           })
                    )
            })
        )
    }
);

export const clearUpdateIncidentEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, updateincident-epic",
            "clear-updateincident-reset-epic", {
        });
        return action$.pipe(
            ofType(SET, SETSELECTED, RESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);
